import { transitionDuration, transitionFunction } from 'globals/styles';
import { iconMenu } from 'globals/assets';

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  submit: {
    marginLeft: 'auto',
    position: 'relative',
    minHeight: '45px',
  },
  top: {
    padding: '5px 10px',
  },
  bottom: {
    display: 'flex',
    paddingLeft: '20px',
  },
  arrowPlain: {
    margin: '0 5px',
    flex: '0 0 auto',
    backgroundImage: `url("${iconMenu}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '8px',
    transform: 'rotate(180deg)',
    height: '8px',
    width: '8px',
  },
  breadcrumb: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: '0 1 auto',
    transition: `color ${transitionDuration} ${transitionFunction}`,
  },
  breadcrumbWrap: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 0',
    flex: '0 0 auto',
    fontSize: '12px',
    color: 'rgb(49, 63, 72)',
    maxWidth: '315px',
  },
};

export default styles;
